<div class="vo-loader loader">
    <div class="overlay overlay--no-opacity">
        <div class="message-container d-flex flex-column align-items-center">
            <div class="message-header vo-body-bold-16 my-10"
                [innerHtml]="referenceDataLabels.ProgressBarDefaultHeader | localizeLabel"></div>
            <div class="message-body vo-body-regular-12 mb-10"
                [innerHtml]="referenceDataLabels.ProgressBarDefaultBody | localizeLabel"></div>
        </div>
    </div>
</div>